import React from 'react';
import jsonFile from '../../shared/monday-app-association.json';

const MondayAppAssociation = () => {
  return <pre>{JSON.stringify(jsonFile)}</pre>;
};

export default MondayAppAssociation;
